// Packages
import PropTypes from 'prop-types'

// Components
import TestEquipmentForm from 'modules/TestEquipment/components/Form';

// Other
import useApi from 'hooks/useApi';

const TestEquipmentCreateScreen = ({ onClose, onSubmit, parent, parentId }) => {

    const { post: createItem, errors } = useApi('/testequipment',  false)

	const submit = async (values) => {

        if( await createItem({[parent]: parentId, ...values}, 'Test Equipment created!') ) {
    
            onSubmit();
        }
    }


    return(
        <TestEquipmentForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

TestEquipmentCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

TestEquipmentCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    parent: '',
    parentId: ''
}

export default TestEquipmentCreateScreen;